export default __webpack_public_path__ + "static/media/bell.abfa0031.svg";